import { PRESS_SCALE, PRESS_TRANSITION, useReducedMotion } from '@/lib/motion-presets';
import { cn } from '@/lib/utils';
import { motion, type HTMLMotionProps } from 'motion/react';
import type { ReactNode } from 'react';

type PressableProps = Omit<HTMLMotionProps<'div'>, 'children'> & {
	disabled?: boolean;
	children: ReactNode;
};

export default function Pressable({ className, disabled, children, ...props }: PressableProps) {
	const reducedMotion = useReducedMotion();

	return (
		<motion.div
			className={cn(className)}
			whileTap={disabled || reducedMotion ? undefined : { scale: PRESS_SCALE }}
			transition={PRESS_TRANSITION}
			{...props}
		>
			{children}
		</motion.div>
	);
}
